const labels = {
  FaqCategories: {
    'Ref: Page title': 'よくある質問',
    'Ref: Missing Faq': 'FAQがありません',
    'Ref: Go to home page': 'ホームページに移動します',
  },
  FaqCategoryDetails: { 'Ref: Page title': '質問' },
};
export default labels;
